import { subscribeNotify } from "../../@helpers/js/observer.js";
import { addDimensionToDatalayer, getStoredPiwikdimension, putCusDimInDatalayer } from "../../@helpers/js/datalayer.js";
import './@webcomponent/cz-avtableloader.js';

class SearchCompensation {

    constructor(element, {
        meldingCollectiviteitNietGevonden = 'Collectiviteit niet gevonden',
        meldingCollectiviteitNietBeschikbaar = 'Collectiviteit niet beschikbaar',
        collectiviteit,
        verzekeringslabel = 'cz',
        peilJaar = '2024',
        defaultCategoryId = '00022299338',
        defaultCollectiviteit = '000000019',
        displayCollectiviteitKeuzeBox = true,
        matchPrice = ",-",
        matchPercentage = "%",
        displayJaarKeuze = true,
    } = {}) {

        this._element = element;
        this._options = {
            meldingCollectiviteitNietGevonden,
            meldingCollectiviteitNietBeschikbaar,
            collectiviteit,
            verzekeringslabel,
            peilJaar,
            defaultCategoryId,
            defaultCollectiviteit,
            displayCollectiviteitKeuzeBox,
            matchPrice,
            matchPercentage,
            displayJaarKeuze,
        };

        this._init();
    }

    _init() {

        this.toggleSearch = this._element.querySelector('[data-toggle-search]');

        this.collectiveSearch = this._element.querySelector('[data-collective-search]');

        this.searchField = this._element.querySelector('[data-search-field]');
        this.categoryId = this._element.querySelector('[data-category-id]');

        this.collectiveLabel = this._element.querySelector('[data-collective-label]');

        this.yearTabs = this._element.querySelectorAll('[data-collective-year] [data-item]');
        this.resetSearch = this._element.querySelector('[data-reset-search]');

        this.verzekeringsLabels = this._element.querySelectorAll('[data-label]');

        this.collectiveGraph = this._element.querySelector('[data-collective-graph]');
        this.collectiveWrapper = this._element.querySelector('[data-collective-wrapper]');

        this.collectivePackage = this._element.querySelector('[data-collective-package]');
        this.searchContentSection = this._element.querySelector('[data-search-content]');
        this.revealer = this._element.querySelector('[data-revealer]');

        this.yearTabs?.forEach( tab => {
            tab.addEventListener('click', () => {
                this.yearTabs.forEach(t => t.classList.remove('selected'));
                tab.classList.add('selected');
                this.collectiveGraph?.setAttribute('year', tab.textContent);
            });
        });
            
        this.verzekeringsLabels.forEach( label => {
            label.addEventListener('click', () => {
                this.verzekeringsLabels.forEach(l => l.classList.remove('selected'));
                label.classList.add('selected');
                this.collectiveGraph?.setAttribute('brand', label.textContent?.replace(/\s/g,''));
                this.collectiveGraph?.setAttribute('category', label.dataset?.category);
            });
        });

        this.toggleSearch.addEventListener('click', () => this._onToggleSearchClick());
        if (this.resetSearch) { this.resetSearch.addEventListener('click', () => this._onResetSearchClick()); }


        this.showYearSection(this._options.displayJaarKeuze);
        if (this.getCollectivity() !== ('000000000' + this._sanitizeInput(this._options.defaultCollectiviteit)).slice(-9)) {
            this.collectiveLabel.textContent = getStoredPiwikdimension('collectiviteitsnaam');
        }

        this._processCollectivity(true, false);

        const selectcomplete = async (suggestion) => {
            if (!suggestion) return;
            
            if (suggestion.relatienummer) {
                this.setCollectivity(suggestion);
                this.searchField.value = suggestion.relatienummer;
                this._processCollectivity(false, false);
            } else {
                this.showError(this._options.meldingCollectiviteitNietGevonden);
            }
        }

        subscribeNotify("searchsuggestions-selectcomplete", selectcomplete);
    }

    showYearSection(state) {
        const collectiveYear = this._element.querySelector(`[data-collective-year]`);
        if (state) {
            collectiveYear?.classList.remove('t-hidden');
        }
    }

    setCollectivity(collectivity) {
        this._options.collectiviteit = collectivity.relatienummer;
        this.collectiveGraph?.setAttribute('collectivity', collectivity.relatienummer);
        putCusDimInDatalayer(26, collectivity.relatienummer);
        addDimensionToDatalayer('collectiviteit',collectivity.relatienummer);
        addDimensionToDatalayer('collectiviteitsnaam',collectivity.naam);
        this.collectiveLabel.textContent = collectivity.naam;
    }

    getCollectivity() {
        let collect = getStoredPiwikdimension('collectiviteit') ?? this._options.defaultCollectiviteit;
        
        return ('000000000' + this._sanitizeInput(collect)).slice(-9);
    }

    showError(message) {

        // Show error container if field invalidates
        let input = this._element.querySelector('[data-input]');
        if (input) {
            input.classList.add('-has-error');
        }
        let err = this._element.querySelector('[data-error]');
        if (err) {
            err.innerHTML = message;
            err.classList.remove('t-hidden');
        }

        this.showLoadingCollectivity(false);
        this._element.querySelector('.c-input__input')?.focus();
        if (this.toggleSearch.getAttribute('aria-expanded') !== "true") {
            if (this._sanitizeInput(this._options.collectiviteit) === this._sanitizeInput(this._options.defaultCollectiviteit)) {
                this.toggleSearch.classList.remove('t-hidden');
                this.toggleSearch.setAttribute('aria-hidden',false);
                this.collectivePackage.classList.add('t-hidden');
                this.collectivePackage.setAttribute('aria-hidden',true);
            } else {
                this.toggleSearch.classList.add('t-hidden');
                this.toggleSearch.setAttribute('aria-hidden',true);
                this.collectivePackage.classList.remove('t-hidden');
                this.collectivePackage.setAttribute('aria-hidden',false);
            }

            this.showErrorMessage(message);
        }

        return false;
    }

    showErrorMessage(message) {

        // Show error container if major error occurs
        let err = this._element.querySelector('[data-message]');
        if (err) {
            err.innerHTML = message;
            err.classList.remove('t-hidden')
        }

        return false;
    }


    showLoadingCollectivity(state){
        return new Promise( r => {
            if (state) {
                this.searchContentSection.classList.add('loading');
            } else {
                this.searchContentSection.classList.remove('loading');
            }
            setTimeout(r,300);
        });
    }

    _onToggleSearchClick() {
        if (this.toggleSearch.getAttribute('aria-expanded') !== "false") {
            this.searchField.value = '';
        }
    }

    _onResetSearchClick() {

        this.searchField.value = '';
        this.setCollectivity({relatienummer: ('000000000' + this._sanitizeInput(this._options.defaultCollectiviteit)).slice(-9), naam: ''});

        this._processCollectivity(true, true);
    }

    _sanitizeInput(value) {
        if (typeof value === 'number')
            return value;
        // Remove leading zeros and validate only numbers.
        return parseInt(value, 10);
    }

    async _processCollectivity(acceptDefault, removeColl) {

        // Show loading.
        await this.showLoadingCollectivity(true)
        if (removeColl) {
            this.showYearSection(false);
        }
        this.toggleSearch.classList.remove('t-hidden');
        this.toggleSearch.setAttribute('aria-hidden', false);
        this.collectivePackage.classList.add('t-hidden');
        this.collectivePackage.setAttribute('aria-hidden', true);
        if (this.getCollectivity() !== ('000000000' + this._sanitizeInput(this._options.defaultCollectiviteit)).slice(-9)) {
            this.showLoadingCollectivity(false);
            
            this.collectivePackage.classList.remove('t-hidden');
            this.collectivePackage.setAttribute('aria-hidden', false);
            if (this.toggleSearch.getAttribute('aria-hidden') !== "true") {
                if (this.searchContentSection.getAttribute('aria-hidden') !== "true") {
                    this.toggleSearch.dispatchEvent(new Event("click"));
                }
                this.toggleSearch.classList.add('t-hidden');
                this.toggleSearch.setAttribute('aria-hidden', true);
            }

        } else {
            
            if (acceptDefault) {
                this.collectiveLabel.textContent = '';
                this.showLoadingCollectivity(false);

            } else {
                this.showError(this._options.meldingCollectiviteitNietGevonden);
                return false;
            }
        }
    }
}

export default SearchCompensation;
